import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from '../Core/PrivateRoute';
import { PermissionEnum } from '../misc/api/ApiPermissionEnum';
import DocumentTitle from '../misc/components/DocumentTitle';
import { DataCorrectionListScreen } from './List/DataCorrectionListScreen';
import { DataCorrectionRequestView } from './View/DataCorrectionRequestView';
import { EditDataCorrectionRequestWrapper } from './Request/EditDataCorrectionRequest';
import { SearchParams } from '../Components/Query';

export const DataCorrectionListAndViewScreen = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <DocumentTitle title="Data Corrections | Vitalograph Web Portal">
            <Routes>
                <Route path="edit/:dcfRequestId" element={
                    <PrivateRoute permissions={[PermissionEnum.AccessDataCorrections]}>
                    <EditDataCorrectionRequestWrapper />
                    </PrivateRoute>
                }
                />
                <Route path="view/:dcfRequestId" element={
                    <PrivateRoute permissions={[PermissionEnum.AccessDataCorrections]}>
                    <DataCorrectionRequestView />
                    </PrivateRoute>
                }
                />
                <Route index element={
                    <PrivateRoute permissions={[PermissionEnum.AccessDataCorrections]}>
                    <DataCorrectionListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
                    </PrivateRoute>
                }
                />
            </Routes>
        </DocumentTitle>
    );
};
